import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import PriceList from './PriceList.vue';
import PricingPlans from './PricingPlans.vue';
import PricingPlanShow from './PricingPlanShow.vue';
import PricingRuleEditor from './PricingRuleEditor.vue';
import DiscountCodes from './DiscountCodes.vue';

export default {
  routes: [
    {
      path: frontendURL(
        'accounts/:accountId/settings/planning/pricing/price-list'
      ),
      redirect: to => ({
        name: 'settings_pricing_items',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: frontendURL('accounts/:accountId/settings/planning/pricing/rates'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_pricing_items',
          meta: {
            permissions: ['administrator'],
          },
          component: PriceList,
        },
      ],
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/planning/pricing/discount-codes'
      ),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_pricing_discount_codes',
          meta: {
            permissions: ['administrator'],
          },
          component: DiscountCodes,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/planning/pricing/plans'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_pricing_plans',
          meta: {
            permissions: ['administrator'],
          },
          component: PricingPlans,
        },
      ],
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/planning/pricing/plans/:planId'
      ),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_pricing_plan_show',
          meta: {
            permissions: ['administrator'],
          },
          component: PricingPlanShow,
        },
      ],
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/planning/pricing/plans/:planId/rules/:ruleId/view'
      ),
      redirect: to => ({
        name: 'settings_pricing_rule_edit',
        params: {
          planId: to.params.planId,
          ruleId: to.params.ruleId,
        },
      }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/planning/pricing/plans/:planId/rules/:ruleId'
      ),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_pricing_rule_edit',
          meta: {
            permissions: ['administrator'],
          },
          component: PricingRuleEditor,
        },
      ],
    },
  ],
};
